module.exports = __webpack_public_path__ + "static/media/matilde-hat-sri-lanka-bored.6cd6b1e3.png";